import {
  SYSTEMCONFIG_SYSTEMCONFIGTYPE_MODAL_CHANGE,
} from './constants';

export function systemConfigTypeModalChange(visible,type) {
  return {
    type: SYSTEMCONFIG_SYSTEMCONFIGTYPE_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEMCONFIG_SYSTEMCONFIGTYPE_MODAL_CHANGE:
      return {
        ...state,
        systemConfigTypeModalType:action.data.type,
        systemConfigTypeModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/systemconfig/redux/systemConfigTypeModalChange.js